import React, { useState, useEffect } from 'react';
import DateSingleFilter from '../dateSingleFilter';

const DateSingleFilterButton = ({ onDateChange, selectedDate, title, position = " -right-32 md:right-0" }) => {
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [tempDate, setTempDate] = useState(selectedDate || '');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setTempDate(selectedDate || '');
  }, [selectedDate]);

  React.useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const hasActiveDateFilter = !!selectedDate;

  const toggleDateFilter = () => {
    setTempDate(selectedDate || '');
    setShowDateFilter(!showDateFilter);
  };

  const handleDateChange = (date) => {
    setTempDate(date);
  };

  const handleApply = () => {
    if (tempDate) {
      onDateChange(tempDate);
    } else {
      const today = new Date().toISOString().split('T')[0];
      onDateChange(today);
    }
    setShowDateFilter(false);
  };

  return (
    <div className='relative'>
      <button
        onClick={toggleDateFilter}
        className={`flex items-center justify-center font-itcbook px-2 w-[140px] border-blue-light text-sm border-[1px] h-[40px] rounded-lg ${
          hasActiveDateFilter ? 'bg-blue-light text-white' : 'bg-transparent text-[#6B7280]'
        }`}
      >
        Filtrar por fecha
      </button>
      {showDateFilter && (
      <>

      <div 
        onClick={(e) => e.stopPropagation()}
        className={`p-4 bg-white absolute ${position} top-11 rounded-lg w-[266px] sm:w-[355px] z-10 shadow-[0px_1px_3px_0px_#0000004D,0px_4px_8px_3px_#00000026]`}
      >
        <div className='flex flex-col gap-3'>
          <p className='text-base text-blue font-itcbook'>{title}</p>
          <DateSingleFilter 
            onDateChange={handleDateChange}
            selectedDate={tempDate}
          />
          <button
            onClick={handleApply}
            className="underline text-blue font-itcbold">
            Aplicar
          </button>
        </div>
      </div>
      </>
      )}
    </div>
  );
};

export default DateSingleFilterButton;